import { makeAutoObservable, runInAction, action } from 'mobx';
import { State } from '~/store/types';
import { Site, WatcherrError } from '@watcherr/resources';

class GlobalChartStore {
  rootStore: State;
  error?: WatcherrError;
  loading: boolean = false;
  numberOfResidents: number = 0;
  numberOfResidentGroups: number = 0;
  numberOfhealthcareProviders: number = 0;
  numberOfhealthcareProviderGroups: number = 0;

  constructor(rootStore: State) {
    makeAutoObservable(this, {
      loadStats: action.bound,
      rootStore: false,
    });
    this.rootStore = rootStore;
  }

  loadStats() {
    this.loading = true;
    const stats = Site.getSiteStats();
    stats
      .then((data) => {
        runInAction(() => {
          this.numberOfResidents = data.numberOfResidents;
          this.numberOfResidentGroups = data.numberOfResidentGroups;
          this.numberOfhealthcareProviders = data.numberOfhealthcareProviders;
          this.numberOfhealthcareProviderGroups = data.numberOfhealthcareProviderGroups;
          this.loading = false;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.loading = false;
          console.log('Error', err);
          this.error = err;
        });
      });
  }
}

export default GlobalChartStore;
